import { Spinner } from "react-bootstrap";

export function FullViewSpinner() {
  return <div className="w-100 p-5 text-center"><Spinner color={"primary"} /></div>;
}
